import { render, staticRenderFns } from "./SubHistory.vue?vue&type=template&id=318ccef9&"
import script from "./SubHistory.vue?vue&type=script&lang=js&"
export * from "./SubHistory.vue?vue&type=script&lang=js&"
import style0 from "./SubHistory.vue?vue&type=style&index=0&id=318ccef9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports